import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2 },
  { title: 'Ativo', flex: 1.8 },
  { title: 'Qtd. disponível' },
  { title: 'Qtd. indisponível' },
  { title: 'Preço atual' },
  { title: 'Preço médio' },
  {
    title: 'Valor',
    tooltip:
      'O valor apresentado é virtual e pode sofrer alterações. Isso ocorre devido à combinação de posições alugadas e posições em custódia. ',
  },
];

export const getEquityFilters = (): FilterModalTypes.FilterType[] => [
  {
    type: 'date',
    fieldName: 'positionDate',
    title: 'Data posição',
    placeholder: 'Selecione a data da posição',
  },
  {
    type: 'range',
    fieldName: 'totalQuantity',
    labelType: 'number',
    title: 'Quantidade total',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'positionValue',
    labelType: 'money',
    title: 'Valor posição',
    min: 0,
    max: 1000000000,
  },
];
